/** The subset of a mouse event needed to decide how a link click should behave. */
export interface ClickModifiers {
  /** 0 = primary (left) button. */
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}

/**
 * True for an unmodified primary-button click — the case we intercept to open
 * the in-dashboard popup. Any modifier (ctrl/⌘/shift/alt) or non-primary button
 * is left to the browser so native "open in new tab/window" still works.
 */
export function isPlainLeftClick(e: ClickModifiers): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}
